module.exports = __webpack_public_path__ + "static/media/helix-logo-white.f056ec69.svg";